import React from 'react'
import ButtonList from './ButtonList'
import VideoContainer from './VideoContainer'

function MainContainer() {
  return (
    <div className=' w-[82%]'>
        <ButtonList />
        <VideoContainer />
    </div>
  )
}

export default MainContainer